export enum TripTableSort {
    REAL_FINISH_ASC = 'realFinish',
    REAL_START_ASC = 'realStart',
    SCHEDULED_START_ASC = 'scheduledStart',
    TOTAL_DELAY_ASC = 'totalDelay',
    TIME_ASC = 'time',
    METERS_ASC = 'meters',
    VEHICLE_ASC = 'vehicle',

    REAL_FINISH_DESC = '-realFinish',
    REAL_START_DESC = '-realStart',
    SCHEDULED_START_DESC = '-scheduledStart',
    TOTAL_DELAY_DESC = '-totalDelay',
    TIME_DESC = '-time',
    METERS_DESC = '-meters',
}
